// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inherit-height[data-v-252b6811]{height:inherit}.clickable[data-v-252b6811]{color:#e41b51;font-size:.7em;cursor:pointer}.bold-smaller-text[data-v-252b6811]{font-weight:700!important;font-size:.75em}.ai-assistant[data-v-252b6811]{position:absolute;right:0;padding-right:20px;height:inherit;max-width:300px}", ""]);
// Exports
module.exports = exports;
